import photos from '../public/data/photos.json'
import db from '../public/data/database.json'

function getCategories () {
  return Object.keys(db.categories).map(id => getCategory(id))
}

function getCategory (id) {
  if (!hasCategory(id)) return null

  const category = db.categories[id]
  if (!('id' in category)) {
    category.id = id
  }

  if (!('collections' in category)) {
    category.collections = category.collectionIds.map(id => getCollection(id))
  }

  return category
}

function hasCategory (id) {
  return id in db.categories
}

function getCollection (id) {
  if (!hasCollection(id)) return null

  const collection = db.collections[id]

  if (!('id' in collection)) {
    collection.id = id
  }

  if (!('photos' in collection)) {
    collection.photos = collection.photoIds.map(id => getPhoto(id))
  }

  if (!('thumbnail' in collection)) {
    collection.thumbnail = getPhoto(collection.thumbnailId)
  }

  return collection
}

function hasCollection (id) {
  return id in db.collections
}

function getPhoto (id) {
  return { file: photos[id] }
}

function getSplashPhotos () {
  return db.splashIds.map(id => getPhoto(id))
}

export default {
  getCategories,
  getCategory,
  hasCategory,
  getCollection,
  hasCollection,
  getPhoto,
  getSplashPhotos
}
